import CookiesJS from 'cookies-js';

export function initTariffs($, apiClient) {
    $('form.tariff-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const tariff = {
                title: $('#title').val(),
                description: $('#description').val(),
                cost: parseInt($('#cost').val()),
                period: $('#period').val(),
                isDefault: !!$('#isDefault').prop('checked'),
                isDefaultWithTrainer: !!$('#isDefaultWithTrainer').prop('checked'),
                restrictedAssign: !!$('#restrictedAssign').prop('checked'),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/tariffs', tariff, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/tariffs/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/tariffs', _id, tariff, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
